// removed by extract-text-webpack-plugin
module.exports = {"container":"_14OoJ4QlH-F4097ndUbl8h","option":"yRZvfyBn1u_2BCInMYxyU"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/AdvancedSettings/Advance/OwnerView/styles.css
// module id = 2767
// module chunks = 0